/* NOLOS brand marks as React components — single source for the logo.
 *
 * The canonical SVGs live in ./brand/ (mark.svg, wordmark.svg, the lockups).
 * These components inline the mark so it scales crisply and can sit on any
 * background without a network fetch. Use <NolosMark/> for the icon and
 * <NolosWordmark/> for the "NOLOS" lettering (brand mono font).
 */

export function NolosMark({ size = 26, className }: { size?: number; className?: string }) {
  // The five-triangle pinwheel — colours are the brand palette (do not theme).
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 210.282 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="NOLOS"
    >
      <polygon points="105.141,110.558 107.541,0 209.547,74.111" fill="#0c4fab" />
      <polygon points="105.141,110.558 211.030,78.676 172.067,198.591" fill="#18c6d4" />
      <polygon points="105.141,110.558 168.184,201.413 42.098,201.413" fill="#35e5c6" />
      <polygon points="105.141,110.558 38.215,198.591 -0.748,78.676" fill="#a98410" />
      <polygon points="105.141,110.558 0.735,74.111 102.741,0" fill="#a35d17" />
    </svg>
  )
}

export function NolosWordmark({ className }: { className?: string }) {
  return (
    <span
      className={className}
      style={{
        fontFamily: 'var(--font-mono)',
        fontWeight: 700,
        letterSpacing: '0.16em',
      }}
    >
      NOLOS
    </span>
  )
}
